import { render, staticRenderFns } from "./TestMap.vue?vue&type=template&id=97c6a2fc&scoped=true&"
import script from "./TestMap.vue?vue&type=script&lang=js&"
export * from "./TestMap.vue?vue&type=script&lang=js&"
import style0 from "./TestMap.vue?vue&type=style&index=0&id=97c6a2fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c6a2fc",
  null
  
)

export default component.exports